import { useQuery } from '@tanstack/react-query';
import { api_host, api_auth } from '../common/globals/constants';
import { getApiKeys } from '../utils/fns/get-api-keys';

const fetchRendimientoObjetivo = async (user_id, token, objetivoId) => {
  const url = `${api_host}/reporte/online/indicadores/getDetalleRendimientoGlobalObjetivo/?objetivoId=${objetivoId}&token=${token}&key=${api_auth}&horarioId=0&t=d&_=${new Date().getTime()}`;
  const response = await fetch(url);
  if (!response.ok) {
    throw new Error('Network response was not ok');
  }
  return response.json();
};

export const useRendimientoObjetivo = (objetivoId, options = {}) => {
  const {user, token} =getApiKeys()

  return useQuery({
    queryKey: ['rendimientoObjetivo', user, objetivoId],
    queryFn: () => fetchRendimientoObjetivo(user, token, objetivoId),
    enabled: !!user && !!token && !!objetivoId,
    refetchInterval: 300000,
    ...options
  });
};
